/**
 * Footer Section Scripts
 * Handles accordion functionality for footer menus on mobile
 */

const Footer = {
  init: function() {
    this.initAccordion();
  },

  initAccordion: function() {
    const accordionToggles = document.querySelectorAll('.js-footer-accordion-toggle');
    
    if (!accordionToggles.length) return;

    accordionToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const contentId = this.getAttribute('aria-controls');
        const content = document.getElementById(contentId);
        
        // Close all other accordions
        accordionToggles.forEach(function(otherToggle) {
          if (otherToggle !== toggle) {
            otherToggle.setAttribute('aria-expanded', 'false');
            const otherContentId = otherToggle.getAttribute('aria-controls');
            const otherContent = document.getElementById(otherContentId);
            if (otherContent) {
              otherContent.classList.remove('is-open');
            }
          }
        });
        
        // Toggle current accordion
        this.setAttribute('aria-expanded', !isExpanded);
        if (content) {
          content.classList.toggle('is-open');
        }
      });
    });
  }
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  Footer.init();
});

// Re-initialize when Shopify section loads (for theme editor)
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('[data-section-type="footer-section"]')) {
    Footer.init();
  }
});
